module.exports = __webpack_public_path__ + "images/project-public-2875f4e56b6c651e3eaf891e93dd9ada.svg";